/**
 * Used to indicate code that the type system says is unreachable.
 */
export function assertNever(value: never): never {
  throw new Error(`Unhandled value: ${JSON.stringify(value)}`);
}
